(function () {
  var wrap = document.querySelector(".product-detail");
  if (!wrap) return;

  var mainImg = document.getElementById("product-detail-main-img");
  var thumbsEl = document.getElementById("product-detail-thumbs");
  var prevBtn = wrap.querySelector(".product-detail__thumb-arrow--prev");
  var nextBtn = wrap.querySelector(".product-detail__thumb-arrow--next");

  if (!mainImg || !thumbsEl) return;

  var thumbBtns = Array.from(
    thumbsEl.querySelectorAll(".product-detail__thumb"),
  );
  var current = 0;
  var visible = 3;
  var offset = 0;

  var imageSrcMap = {};
  thumbBtns.forEach(function (btn, i) {
    var img = btn.querySelector("img");
    if (img) {
      imageSrcMap[i] = {
        src: btn.dataset.largeSrc || img.src,
        srcset: btn.dataset.largeSrcset || img.srcset || "",
        sizes: btn.dataset.largeSizes || img.sizes || "",
        alt: img.alt || "",
      };
    }
  });

  function applyOffset() {
    var thumb = thumbsEl.querySelector(".product-detail__thumb");
    if (!thumb) return;
    var thumbW = thumb.offsetWidth + 16; // 16px matches the CSS gap between thumbnails
    thumbsEl.style.transform = "translateX(-" + offset * thumbW + "px)";
  }

  var heroBadge = document.getElementById("product-detail-block-badge");

  function setActive(index) {
    current = index;

    var data = imageSrcMap[index];
    if (data) {
      mainImg.src = data.src;
      mainImg.srcset = data.srcset;
      mainImg.sizes = data.sizes;
      mainImg.alt = data.alt;
    }

    thumbBtns.forEach(function (btn, i) {
      btn.classList.toggle("is-active", i === index);
    });

    // Sync the badge ("Block #X" or "Book Match") on the hero image
    if (heroBadge) {
      var badge = (thumbBtns[index] && thumbBtns[index].dataset.badge) || "";
      heroBadge.textContent = badge;
      heroBadge.classList.toggle(
        "product-detail__block-badge--hidden",
        !badge,
      );
    }

    if (index < offset) {
      offset = index;
    } else if (index >= offset + visible) {
      offset = index - visible + 1;
    }
    applyOffset();
  }

  thumbBtns.forEach(function (btn, i) {
    btn.addEventListener("click", function () {
      setActive(i);
    });
  });

  var total = thumbBtns.length;

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      // Wrap to the last image when going back from the first
      setActive((current - 1 + total) % total);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      // Wrap to the first image when going forward from the last
      setActive((current + 1) % total);
    });
  }
})();

// ----- Hover-to-magnify on the main product image -----
// Standalone so it runs even on single-image products (where the thumbnail
// strip — and thus the gallery block above — never renders). Desktop-only
// (hover + fine pointer): the cursor acts as a magnifier, scaling the image in
// place and panning so the point under the cursor stays put. The frame's
// overflow:hidden clips the enlarged image to the box.
(function () {
  var ZOOM_SCALE = 2.2;
  var frame = document.querySelector(".product-detail__main-image");
  var img = document.getElementById("product-detail-main-img");
  if (!frame || !img) return;

  var canHover =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!canHover) return;

  frame.classList.add("is-zoomable");

  // Pan by translating the scaled image rather than shifting transform-origin,
  // so the CSS transition can ease the movement (no per-mousemove snapping).
  // The point under the cursor stays put, like a real magnifier glass.
  var movePan = function (e) {
    var frameRect = frame.getBoundingClientRect();
    // offsetWidth/Height are the untransformed layout size, so they stay stable
    // while the image is scaled — unlike getBoundingClientRect.
    var imgW = img.offsetWidth;
    var imgH = img.offsetHeight;
    if (!imgW || !imgH) return;
    // Cursor position normalised to the image's (letterboxed) box, clamped so
    // panning into the margins can't push past the image edges.
    var x = (e.clientX - frameRect.left - (frameRect.width - imgW) / 2) / imgW;
    var y = (e.clientY - frameRect.top - (frameRect.height - imgH) / 2) / imgH;
    x = Math.min(Math.max(x, 0), 1);
    y = Math.min(Math.max(y, 0), 1);
    // (1 - scale) * offset-from-centre keeps the cursor's point fixed as it zooms.
    var panX = (1 - ZOOM_SCALE) * (x - 0.5) * imgW;
    var panY = (1 - ZOOM_SCALE) * (y - 0.5) * imgH;
    img.style.setProperty("--zoom-pan-x", panX + "px");
    img.style.setProperty("--zoom-pan-y", panY + "px");
  };

  frame.addEventListener("mouseenter", function (e) {
    movePan(e);
    img.style.setProperty("--zoom-scale", String(ZOOM_SCALE));
  });
  frame.addEventListener("mousemove", movePan);
  frame.addEventListener("mouseleave", function () {
    img.style.setProperty("--zoom-scale", "1");
    img.style.setProperty("--zoom-pan-x", "0px");
    img.style.setProperty("--zoom-pan-y", "0px");
  });
})();

// Related products carousel
document.addEventListener("DOMContentLoaded", function () {
  var emblaNode = document.querySelector(".embla-related");
  if (!emblaNode || typeof EmblaCarousel === "undefined") return;

  var viewport = emblaNode.querySelector(".embla-related__viewport");
  var prevBtn = emblaNode.querySelector(".embla-related__btn--prev");
  var nextBtn = emblaNode.querySelector(".embla-related__btn--next");
  var controls = emblaNode.querySelector(".embla-related__controls");
  var count = parseInt(emblaNode.dataset.count || "0", 10);

  // Mirror the image-mosaic carousel (which works cleanly at the first/last
  // slide on mobile): a plain looping carousel. Looping means there's no hard
  // "end" to land flush against, so the last card wraps seamlessly to the first
  // with the normal inter-slide gap.
  var embla = EmblaCarousel(viewport, {
    loop: true,
    align: "start",
  });

  function updateControls() {
    if (!controls) return;
    var w = window.innerWidth;
    var visible = w <= 520 ? 1 : w <= 900 ? 2 : 3;
    controls.style.display = count > visible ? "" : "none";
  }

  updateControls();
  window.addEventListener("resize", updateControls);

  if (prevBtn)
    prevBtn.addEventListener("click", function () {
      embla.scrollPrev();
    });
  if (nextBtn)
    nextBtn.addEventListener("click", function () {
      embla.scrollNext();
    });
});
